import { formatters } from "@/helpers/formatters";
import { InputDictionary } from "@/types/common";

export default <InputDictionary[]>[
  {
    title: "Week",
    value: "week",
    formatter: formatters.formatWeekLabel,
  },
  {
    title: "Month",
    value: "month",
    formatter: formatters.formatMonth,
  },
  {
    title: "Quarter",
    value: "quarter",
    formatter: formatters.formatQuarter,
  },
];
